import React from "react";
import { Menu } from "@base-ui/react/menu";
import { IconButton } from "../icon-button";
import { FloatingMenu } from "../floating-menus/floating-menu";
import { BadgeWrapper } from "../badge/badge";
import { useProductErrorsAndWarnings } from "../../hooks/useProductErrorsAndWarnings";
import { InfoMenuItem } from "../floating-menus/info-menu-item";
import { MySavedProductsMenuItem } from "../floating-menus/my-saved-products-menu-item";
import { ResetCdnUrlMenuItem } from "../floating-menus/reset-cdn-url-menu-item";
import { RestartMenuItem } from "../floating-menus/restart-menu-item";
import { SaveMenuItem } from "../floating-menus/save-menu-item";
import { ValidationsMenuItem } from "../floating-menus/validation-menu-item";
import { Version } from "../version";

enum BadgeType {
	"error",
	"warning",
}

const FloatingBadge = ({ badgeType }: { badgeType: BadgeType | null }) => {
	if (badgeType !== null) {
		if (badgeType === BadgeType.warning)
			return <BadgeWrapper className="floating-menu__badge--warning" />;
		if (badgeType === BadgeType.error)
			return <BadgeWrapper className="floating-menu__badge--error" />;
	}

	return null;
};

export function EllipseMenu() {
	// Check Validation errors
	const { productErrorsAndWarnings } = useProductErrorsAndWarnings();
	const badgeType =
		productErrorsAndWarnings.length === 0
			? null
			: productErrorsAndWarnings.some((err) => err.isError)
			? BadgeType.error
			: BadgeType.warning;

	return (
		<Menu.Root>
			<Menu.Trigger
				render={(props) => (
					<span>
						<IconButton iconName="dots-vertical" elevated {...props} />
						<FloatingBadge badgeType={badgeType} />
					</span>
				)}
			></Menu.Trigger>
			<Menu.Portal>
				<Menu.Positioner sideOffset={10} align="end">
					<Menu.Popup>
						<FloatingMenu>
							<SaveMenuItem />
							<RestartMenuItem />
							<InfoMenuItem />
							<MySavedProductsMenuItem />
							<ValidationsMenuItem />
							<ResetCdnUrlMenuItem />
							<Version />
						</FloatingMenu>
					</Menu.Popup>
				</Menu.Positioner>
			</Menu.Portal>
		</Menu.Root>
	);
}
